import React, { Component } from "react";
import LoginHeader from "../common/LoginHeader";
import '../../styles/login.css';
import {appBasePath, imageBasePath} from "../../constants/staticData";
import { relative } from "path";

export default class NonVerified extends Component {
  constructor(props) {
    super(props);


  }

  componentWillMount() {


    this.props.actions.getAccountStatus();


  }
  componentWillUnmount() {



    this.props.actions.hideErrorMessage();

  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.authReducer && nextProps.authReducer.authData) {

      console.log("nextProps.authReducer.authData.businessstatus ",nextProps.authReducer.authData )

      if(nextProps.authReducer.authData.businessstatus == 2){
        //localStorage.clear();

        localStorage.setItem('businessAuthData', JSON.stringify(nextProps.authReducer.authData));
        localStorage.setItem('businessUserId', JSON.stringify(nextProps.authReducer.authData.id));
        //localStorage.setItem('businessAccessToken', nextProps.authReducer.authData.token);
        localStorage.setItem('garage_id', nextProps.authReducer.authData.garageId);


        this.props.router.push(`${appBasePath}/sign-in`);
      }

    }



  }




  render() {
    const divStyle = {
      'display': 'block',
      'margin-left': 'auto',
      'margin-right': 'auto',
      'width': '100%'
    }

    return (
      <div className="container-fluid" id="wrapper">
        <LoginHeader actions={this.props.actions} router={this.props.router} float={true}/>
        <div>
          <img src={`${imageBasePath}/business-nonverified-bg.png`}
            alt="nonverified" style={divStyle}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/NonVerified.jsx